<ng-container *idtLet="(layout$ | async) as layout">
  <render-layout
    *ngIf="layout"
    [layout]="layout">
  </render-layout>
  <render-svg-sprite hidden></render-svg-sprite>
</ng-container>
